<template>
  <div>
    <LoadingFullScreenSpinner
      v-if="!isMapClusterReady"
      :loading-text="$t('carte.loading-projects')"
    />
    <MapDrawWithClusterView
      v-if="isMapClusterReady"
      class="MapDrawView"
      :validation-activated="false"
      :show-validation-errors="false"
      :logged-user="loggedUser"
      :map-has-focus="true"
      :projets="projets"
      :guest="guest"
      :role="role"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import MapDrawWithClusterView from "@/views/maps/MapDrawWithClusterView.vue"
import { GraeService } from "@/services/rest/grae/GraeService"
import { AireEducativeCartoDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { LoginService } from "@/services/rest/login/LoginService"
import LoadingFullScreenSpinner from "@/views/generic_components/LoadingFullScreenSpinner.vue"

export default defineComponent({
  name: "MapClusterComponent",
  components: {
    LoadingFullScreenSpinner,
    MapDrawWithClusterView,
  },
  data() {
    return {
      graeService: GraeService.INSTANCE,
      loginService: LoginService.INSTANCE,
      projets: [] as Array<AireEducativeCartoDTO>,
      innerLoggedUser: new UtilisateurDTO() as UtilisateurDTO | undefined,
      loggedUser: new UtilisateurDTO() as UtilisateurDTO | undefined,
      guest: true,
      role: undefined as string | undefined,
      isMapClusterReady: false,
    }
  },
  watch: {
    loggedUser(newLoggedUser: UtilisateurDTO): void {
      if (this.innerLoggedUser?.id != newLoggedUser?.id) {
        this.innerLoggedUser = newLoggedUser
        this.reloadData()
      }
    },
  },
  async created(): Promise<void> {
    this.loggedUser = await this.loginService.getLoggedUser()
    this.innerLoggedUser = this.loggedUser
    await this.reloadData()
  },
  methods: {
    async reloadData(): Promise<void> {
      this.isMapClusterReady = false
      // this.Projets = []
      try {
        this.guest = !this.innerLoggedUser?.id
        this.role = this.innerLoggedUser?.profil ? this.innerLoggedUser?.profil : ""
        if (this.projets.length === 0) {
          this.projets = await this.graeService.getAllEtablissements()
        }
      } catch (e: any) {
        console.error("Erreur lors du rechargement des données", e)
      } finally {
        this.isMapClusterReady = true
      }
    },
  },
})
</script>
